<ng-container>
    <p-confirmDialog #cdx [style]="{width: '{{message.size}}vw'}" key="information" [closable]="false">
        <ng-template pTemplate="header">
            <div class="mt-2"></div>
        </ng-template>
        <ng-template pTemplate="footer">
            <button type="button" pButton label="Aceptar" (click)="cdx.accept()"></button>
        </ng-template>
    </p-confirmDialog>
</ng-container>